import space from 'color-space';

export const spaceToSpace = (
  numbers: number[],
  from: string,
  to: string
): number[] => space[from][to](numbers);
